import { createTheme } from "@mui/material/styles";

/**
 * Alineación visual con UI Kit 2.0.
 * Valores espejo de tokens.css (MUI necesita hex resueltos para derivar
 * estados hover/focus/disabled). Si cambia un hex aquí, actualizar
 * el token --ds-* correspondiente en tokens.css y viceversa.
 */
const violet50 = "#f4ecfb";
const violet700 = "#6b21a8";
const violet800 = "#581c87";
const cream50 = "#f4f1ec";

const status = {
  good: "#006b3f",
  bad: "#b91c1c",
  warn: "#d4580a",
  info: "#1f5e9e",
  goodSoft: "#e8f5ee",
  badSoft: "#fee2e2",
  warnSoft: "#fef3c7",
  infoSoft: "#dbeafe",
};

const uiKitLineHeight = { body: 1.4, overline: 1.2 };
const inheritedBodyLineHeight = 1.5;

export const theme = createTheme({
  shape: { borderRadius: 12 },
  typography: {
    body1: { lineHeight: uiKitLineHeight.body },
    body2: { lineHeight: uiKitLineHeight.body },
    caption: { lineHeight: uiKitLineHeight.body },
    overline: { lineHeight: uiKitLineHeight.overline },
  },
  palette: {
    primary: {
      main: violet700,
      dark: violet800,
      light: violet50,
      contrastText: cream50,
    },
    success: {
      main: status.good,
      light: status.goodSoft,
      contrastText: "#ffffff",
    },
    error: {
      main: status.bad,
      light: status.badSoft,
      contrastText: "#ffffff",
    },
    warning: {
      main: status.warn,
      light: status.warnSoft,
      contrastText: "#ffffff",
    },
    info: {
      main: status.info,
      light: status.infoSoft,
      contrastText: "#ffffff",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: { body: { lineHeight: inheritedBodyLineHeight } },
    },
    MuiButton: {
      styleOverrides: { root: { borderRadius: 12 } },
    },
    MuiOutlinedInput: {
      styleOverrides: { root: { borderRadius: 999 } },
    },
    MuiPaper: {
      styleOverrides: { root: { borderRadius: 16 } },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6 },
        colorSuccess: {
          backgroundColor: status.goodSoft,
          color: status.good,
        },
        colorWarning: {
          backgroundColor: status.warnSoft,
          color: status.warn,
        },
        colorError: {
          backgroundColor: status.badSoft,
          color: status.bad,
        },
        colorInfo: {
          backgroundColor: status.infoSoft,
          color: status.info,
        },
      },
    },
  },
});
